import Image from 'next/image';
import { SwiperSlide } from 'swiper/react';

import { SwiperBlock } from '@/components/carouselsBlocks/SwiperBlock';
import { Breakpoints, Program, Role } from '@/types';
import { RoleWithPrograms } from '@/types/search';

export interface SearchRolesBlockProps {
  block: { items: Role[]; title?: string; UUID?: string };
  onClick: (roleWithPrograms: RoleWithPrograms) => void;
}

export const SearchRolesBlock = ({ block, onClick }: SearchRolesBlockProps) => {
  const { items: roles, title } = block;

  const handleDisplayRole = (name: string, programs: Program[], UUID: string) => {
    onClick({ name, programs, UUID });
  };

  return (
    <div className="blocks">
      <h2 className="title">{title}</h2>
      <SwiperBlock
        slidesPerView={3.4}
        slidesPerGroup={2}
        slidesOffsetAfter={20}
        slidesOffsetBefore={20}
        spaceBetween={20}
        navigation={true}
        freeMode={true}
        className="block-swiper"
        breakpoints={{
          [Breakpoints.Small]: {
            slidesPerView: 4.4,
            slidesPerGroup: 4,
          },
          [Breakpoints.Medium]: {
            slidesPerView: 5.4,
            slidesPerGroup: 5,
          },
          [Breakpoints.Large]: {
            slidesPerView: 6.4,
            slidesPerGroup: 6,
          },
          [Breakpoints.ExtraLarge]: {
            slidesPerView: 7.6,
            slidesPerGroup: 6,
          },
        }}
      >
        {roles.map((role) => (
          <SwiperSlide key={role.UUID}>
            <button
              className="w-full"
              onClick={() => handleDisplayRole(role.name, role.programs, role.UUID)}
            >
              <div className="img-rounded">
                <Image
                  src={role.avatarURL}
                  alt={role.name}
                  className="bg-[url('/logo-majelan-m.png')] bg-center bg-no-repeat bg-[length:25px_25px] bg-opacity-20"
                  loading="lazy"
                  fill
                />
              </div>
              <p className="text-center mt-3">{role.name}</p>
            </button>
          </SwiperSlide>
        ))}
      </SwiperBlock>
    </div>
  );
};
